import axios from 'axios';
import router from '@/router';
import {
	MessageBox,
	Message
} from 'element-ui'
import {
	RETURN
} from 'vue-element-extends';

const httpURL = window.location.origin == "http://localhost:8289" ? "http://localhost:53849" : window.location.origin;
const websocketurl = window.location.origin == "http://localhost:8289" ? 'ws://localhost:53848/' :	'ws://114.219.56.5:53848/';
const hikvisionVideoUrl = window.location.origin == "http://localhost:8289" ? 'http://localhost:8099' :	'http://114.219.56.5:8099';
const fileupload = httpURL + '/Httphandler/Upload/upload_excel.ashx';


//66测试环境
// const httpURL = 'http://58.216.185.26:2001';
// const websocketurl = 'ws://58.216.185.26:53848/';
// const hikvisionVideoUrl = 'http://58.216.185.26:8099';
// const fileupload = httpURL + '/Httphandler/Upload/upload_excel.ashx';


//正式环境
// const httpURL = 'http://www.actzpt.com';
// const websocketurl = 'ws://114.219.56.5:53848';
// const hikvisionVideoUrl = 'http://114.219.56.5:8099';
// const fileupload = httpURL + '/Httphandler/Upload/upload_excel.ashx';


axios.defaults.timeout = 3000000; //请求超时5秒
axios.defaults.baseURL = ''; //请求base url
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'; //设置post请求是的header信息
axios.defaults.withCredentials = false;

axios.interceptors.request.use(
	config => {
		let token = sessionStorage.getItem('token')
		if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers = {
				'X-token': token
			}
		}

		return config
	},
	err => {
		return Promise.reject(err)
	}
)
//http request 拦截器
axios.interceptors.response.use(
	response => {
		if (response.data.code === 4003) {
			Message({
				message: '您没有权限操作！',
				type: 'error',
				duration: 1500
			})
			return false;
		}
		if (response.data.code === -1) {
			router.push({
				path: "/login",
				querry: {
					redirect: router.currentRoute.fullPath
				} //从哪个页面跳转
			})
		}
		return response
	},
	err => {
		if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
			Message({
				message: '网络异常，连接超时...',
				type: 'error',
				duration: 1500
			})
		}
		return Promise.reject(err)
	}
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}, headers = {}, timeout = 3000000) {
	let that = this;
	if (params == null) {
		params = {};
	}
	params.LoginUserId = that.$cookies.get("LoginUserId");
	params.LoginUserAcct = that.$cookies.get("LoginUserAcct");
	params.LoginEmpId = that.$cookies.get("LoginEmpId");
	params.LoginEmpName = that.$cookies.get("LoginEmpName");
	params.LoginEnId = that.$cookies.get("LoginEnId");
	params.LoginEnType = that.$cookies.get("LoginEnType");

	return new Promise((resolve, reject) => {
		axios.get(httpURL + url, {
				params: params,
				headers: headers,
				timeout: timeout
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				reject(err)
			})
	})
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
	let that = this;
	if (data == null) {
		data = {};
	}
	data.LoginUserId = that.$cookies.get("LoginUserId");
	data.LoginUserAcct = that.$cookies.get("LoginUserAcct");
	data.LoginEmpId = that.$cookies.get("LoginEmpId");
	data.LoginEmpName = that.$cookies.get("LoginEmpName");
	data.LoginEnId = that.$cookies.get("LoginEnId");
	data.LoginEnType = that.$cookies.get("LoginEnType");

	return new Promise((resolve, reject) => {
		that.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		axios.post(httpURL + url, data)
			.then(response => {
				that.$loading().close();
				resolve(response.data);
			}, err => {
				that.$loading().close();
				reject(err)
			})
	})
}

//打开遮罩层
export function showLoading() {
	this.$loading({
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});
}

//关闭遮罩层
export function closeLoading() {
	this.$loading().close();
}

export function getHttpUrl() {
	return httpURL;
}

export function getWebsocketurl() {
	return websocketurl;
}
export function getHikvisionVideoUrl() {
	return hikvisionVideoUrl;
}
//下载Excel导入模板
export function downExcelTemplate(fileName) {
	window.open(httpURL + '/Down/Excel/' + fileName + '.xlsx', "_blank");
}
export function getFileuploadUrl() {
	return fileupload;
}


// WEBPACK FOOTER //
// ./src/common/js/request.js